export default function PlateExperimentControl({state,selectedExperimentId, setSelectedExperimentId}){

  let { experiments } = state;
  let ids = Object.keys(experiments);



  return (
    <div style={{width:150}} class="full-height outline">
      <div class="small-margin" style={{textAlign:'center'}}>
        <button style={{alignText:'center'}} onClick={() => {
          setSelectedExperimentId("new");
        }}>New Plate</button>
      </div>


      <div style={{borderTop:'1px solid #aaa'}}>
        {ids.map(id => {
          return <div style={{paddingLeft:5}} class={`hoverable ${id === selectedExperimentId ? "selected" : ""}` } onClick={() => setSelectedExperimentId(id)}>{ id}</div>
        })}
      </div>
    </div>
  )


}
